import React from 'react'
import { DataForm } from '../../../../../libs/react-mpk/components'
import { number } from '../../../../../libs/react-mpk/services'
import t from 'counterpart'
import { storage } from '../../../../../services'
import { inject, observer } from 'mobx-react'

const { inputTypes } = DataForm

const BagianD = ({
  defaultData = {},
  ...props
}) => {
  const indukData = storage.get(storage.keys.SPT_1770S_INDUK)
  const getUpdateData = (data) => {
    data.D15 = number.sumFormatted(data.D14a, data.D14b)
    return data
  }

  return (
    <DataForm
      baseId={`spt-1770S-induk-D`}
      className="mpk-padding-NONE padding-all"
      asDialog={false}
      editable={props.isEditable}
      defaultData={{...defaultData, ...getUpdateData(defaultData)}}
      definitions={[
        {
          inputType: inputTypes.INPUT,
          label: t.translate(`modules.submission.sptForm.1770S.Induk.D12`),
          helpText: t.translate(`modules.submission.sptForm.1770S.Induk.D12Help`),
          key: 'D12',
          disabled: true
        },
        {
          inputType: inputTypes.SELECT,
          label: t.translate(`modules.submission.sptForm.1770S.Induk.FlgD13`),
          key: 'flagD13',
          options: props.envStore.env.spt.FlgD16,
          disabled: true
        },
        {
          inputType: inputTypes.INPUT,
          label: (d) => (t.translate(`modules.submission.sptForm.1770S.Induk.D13-${d.flagD13}`)),
          key: 'D13',
          readOnly: true
        },
        {
          inputType: inputTypes.INPUT,
          label: t.translate(`modules.submission.sptForm.1770S.Induk.D14a`),
          key: 'D14a',
        },
        {
          inputType: inputTypes.INPUT,
          label: t.translate(`modules.submission.sptForm.1770S.Induk.D14b`),
          key: 'D14b',
        },
        {
          inputType: inputTypes.INPUT,
          label: t.translate(`modules.submission.sptForm.1770S.Induk.D15`),
          key: 'D15',
          disabled: true
        }
      ]}
      onBeforeChange={(key, value) => (
        number.format(number.clearFormat(value.replace(/\D/g, '')))
      )}
      onChange={data => {
        const update = getUpdateData(data)
        return {...data, ...update}
      }}
      onSubmit={(data, callback) => {
        props.onSave({D:data});
        callback(t.translate('sentence.savedItem'), false)
      }}
      submitLabel={t.translate('column.save')}
    />
  )
}

export default inject('envStore')(observer(BagianD))
